import React from 'react';
import classNames from 'classnames';

import styles from './Button.module.scss';

const { 'base-button': baseButtonClasses } = styles;

const Button = ({
  clickAction,
  copy = '',
  border = '',
  color = 'everdays-blue',
  width = 'auto',
  customClass = '',
  type
}) => {
  const copyColor = color === 'white' ? 'black-copy' : 'white-copy';
  const widthClass = width === 'auto' || width === 'full' ? styles[width] : null;
  const additionalClasses = [color, border, copyColor].map(style => styles[style]).filter(Boolean);
  const buttonClasses = classNames(baseButtonClasses, additionalClasses, {
    [widthClass]: widthClass
  });
  const getWidth = () => (!widthClass ? `${width}rem` : '');

  return (
    <button
      {...{ type }}
      className={`${buttonClasses} ${customClass}`}
      onClick={clickAction}
      style={{ width: getWidth() }}
    >
      {copy}
    </button>
  );
};

export default Button;
